/* ==========================================================================
   *** TIMER CONFIG — change this one number to adjust the undo window ***
   ========================================================================== */
var ANSON_DELETE_TIMER_SECONDS = 5; // ← seconds the Undo row stays (e.g. 5 = 5 sec, 60 = 1 min)
/* ========================================================================== */

/* ==========================================================================
   Anson cart: instant remove + timed Undo — slide cart AND /cart page
   Vanilla JS, no dependencies.

   FLOW (both surfaces):
     1. Trash tapped (quantity 1) → the line(s) are snapshotted (variant,
        title, URL, position, quantity, every property incl. hidden "_" keys)
        and removed for real, right away. Totals update immediately.
     2. An Undo row takes the removed line's place: warning icon, "Removed
        {title}.", Undo, and a 3px bar along its bottom edge.
     3. The bar's CSS animation IS the clock — no setTimeout. When it ends
        (animationend) the row disappears and the snapshot is discarded.
        Pausing the animation pauses the clock: hover (real mouse devices,
        pure CSS), keyboard focus on Undo, finger held on the row.
     4. Undo → the exact same line(s) are added back with /cart/add.js.
     5. Redraws (another update re-renders the cart) put the row back at the
        bar's current progress — the countdown never restarts.
     Checkout tapped while a request is in flight waits for it, so checkout
     never opens with the removed line.

   SLIDE CART  : removal is POST /cart/change.js { id, quantity: 0 }, then the
                 returned sections re-render the drawer.
   /CART PAGE  : the page has its own removal code (linked add-on lines, free
                 hanger). The trash clicks the line's Remove link so that code
                 runs unchanged; this script snapshots the cart lines first,
                 then detects what the page changed, and Undo re-adds exactly
                 that difference.
   ========================================================================== */
(function () {
  'use strict';

  var UNDO_MS  = (window.ANSON_DELETE_TIMER_SECONDS || ANSON_DELETE_TIMER_SECONDS) * 1000;
  var DRAWER   = '#CartDrawer';
  var PAGE     = '.main-cart-sections';
  var pending  = {};              // id -> entry
  var inflight = 0;
  var inflightChain = Promise.resolve();
  var sampling = false;
  var internalClick = false;      // our own programmatic click on the page's Remove link

  var WARN_SVG =
    '<svg class="cart-undo__icon" width="18" height="16" viewBox="0 0 18 16" fill="none" ' +
    'stroke="currentColor" stroke-width="2" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="M9 1.5L17 14.5H1z"/><path d="M9 6.2v3.8M9 12.2v.4" stroke-linecap="round"/></svg>';

  /* ------------------------------------------------------------------ */
  /* helpers                                                              */
  /* ------------------------------------------------------------------ */
  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart request failed: ' + res.status);
      return res.json();
    });
  }

  function announce(text) {
    document.querySelectorAll(DRAWER + ' [data-cart-announcer], ' + PAGE + ' [data-cart-announcer]').forEach(function (el) {
      el.textContent = '';
      setTimeout(function () { el.textContent = text; }, 50);
    });
  }

  function track(eventName, line) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, product_title: line.title, variant_id: line.variantId });
  }

  function readLine(lineEl) {
    var propsEl = lineEl.querySelector('.cart-line__props');
    var plan    = lineEl.getAttribute('data-selling-plan');
    var qtyAttr = Number(lineEl.getAttribute('data-quantity'));
    var qtyEl   = lineEl.querySelector('.quantity__input');
    var props   = {};
    try {
      var raw = propsEl ? JSON.parse(propsEl.textContent || '{}') : {};
      // Liquid's `properties | json` gives [["key","value"], ...]; /cart/add.js needs {key: value}
      if (Array.isArray(raw)) {
        raw.forEach(function (pair) { if (Array.isArray(pair) && pair.length) props[pair[0]] = pair[1]; });
      } else if (raw && typeof raw === 'object') {
        props = raw;
      }
    } catch (e) { props = {}; }
    return {
      key:         lineEl.getAttribute('data-line-key'),
      variantId:   Number(lineEl.getAttribute('data-variant-id')),
      quantity:    qtyAttr || (qtyEl && Number(qtyEl.value)) || 1,
      title:       lineEl.getAttribute('data-title'),
      url:         lineEl.getAttribute('data-url'),
      index:       Number(lineEl.getAttribute('data-index')) || 0,
      sellingPlan: plan ? Number(plan) : null,
      properties:  props
    };
  }

  function toAddItem(c, quantity) {
    var item = { id: c.variantId, quantity: quantity || c.quantity || 1, properties: c.properties || {} };
    if (c.sellingPlan) item.selling_plan = c.sellingPlan;
    return item;
  }

  function stripFor(id) { return document.querySelector('.cart-undo[data-undo-id="' + id + '"]'); }

  function trackInflight(promise) {
    inflight++;
    var done = function () { inflight--; };
    var settled = promise.then(done, done);
    inflightChain = Promise.all([inflightChain, settled]).then(function () {});
  }

  /* ------------------------------------------------------------------ */
  /* SLIDE CART — section rendering, same approach the theme uses         */
  /* ------------------------------------------------------------------ */
  function sectionIds() {
    var ids = ['cart-drawer'];
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    return ids;
  }

  function sectionHTML(html, selector) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return node ? node.innerHTML : null;
  }

  function applyBubble(sections) {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections && sections['cart-icon-bubble']) {
      var html = sectionHTML(sections['cart-icon-bubble'], '.shopify-section');
      if (html !== null) bubble.innerHTML = html;
    }
  }

  function applySections(sections, itemCount) {
    if (!sections) return;
    var html;
    applyBubble(sections);

    var inner = document.querySelector(DRAWER + ' .drawer__inner');
    // Replacing the drawer's HTML collapses the scroll container and the browser
    // resets it to the top, so remember where the shopper was and put it back.
    var scrollTop = inner ? inner.scrollTop : 0;
    if (inner && sections['cart-drawer']) {
      html = sectionHTML(sections['cart-drawer'], '.drawer__inner');
      if (html !== null) inner.innerHTML = html;
      if (typeof itemCount === 'number') {
        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) drawerEl.classList.toggle('is-empty', itemCount === 0);
      }
    }

    renderUndoRows();

    if (inner && scrollTop) {
      inner.scrollTop = scrollTop;
      requestAnimationFrame(function () { inner.scrollTop = scrollTop; });
    }
  }

  function refreshBubble() {
    if (!document.getElementById('cart-icon-bubble')) return Promise.resolve();
    return fetch('/cart?sections=cart-icon-bubble&_=' + Date.now())
      .then(function (r) { return r.json(); })
      .then(applyBubble)
      .catch(function () {});
  }

  /* ------------------------------------------------------------------ */
  /* where the Undo row lives                                             */
  /* ------------------------------------------------------------------ */
  /* Returns the line container for a surface. When the cart is now empty
     the theme renders no container, so a temporary host is built. */
  function listFor(surface) {
    var root = document.querySelector(surface === 'page' ? PAGE : DRAWER);
    if (!root) return null;
    var list = root.querySelector(surface === 'page' ? 'ul.cart-items-list' : '[data-cart-lines]');
    if (list) return list;

    var host = document.createElement('div');
    host.setAttribute('data-undo-host', '');
    if (surface === 'page') {
      host.className = 'cart-undo-host';
      host.innerHTML = '<ul role="list" class="cart-items-list" style="list-style:none;margin:0;padding:0;"></ul>';
      root.insertBefore(host, root.firstChild);
      return host.querySelector('ul');
    }
    host.className = 'drawer__cart-items-wrapper';
    host.innerHTML = '<table class="cart-items" role="presentation"><tbody data-cart-lines></tbody></table>';
    var inner = root.querySelector('.drawer__inner-empty') || root.querySelector('.drawer__inner') || root;
    inner.insertBefore(host, inner.firstChild);
    return host.querySelector('[data-cart-lines]');
  }

  function cleanupHosts() {
    document.querySelectorAll('[data-undo-host]').forEach(function (h) {
      if (!h.querySelector('.cart-undo')) h.remove();
    });
  }

  /* ------------------------------------------------------------------ */
  /* the Undo row                                                         */
  /* ------------------------------------------------------------------ */
  function buildUndoRow(entry, elapsed) {
    var timing = ' style="animation-duration:' + UNDO_MS + 'ms;animation-delay:-' + Math.round(elapsed) + 'ms"';
    var inner =
      '<p class="cart-undo__msg">' +
        WARN_SVG.replace('<svg ', '<svg' + timing + ' ') +
        '<span>Removed <strong>' + escapeHTML(entry.line.title) + '</strong>.</span>' +
      '</p>' +
      '<button type="button" class="cart-undo__btn">Undo</button>' +
      '<span class="cart-undo__bar" aria-hidden="true"' + timing + '></span>';

    var el;
    if (entry.surface === 'page') {
      el = document.createElement('li');          // cart page rows are <li>
      el.innerHTML = inner;
    } else {
      el = document.createElement('tr');          // slide cart rows are <tr><td>
      var td = document.createElement('td');
      td.setAttribute('colspan', '99');
      td.innerHTML = inner;
      el.appendChild(td);
    }
    el.className = 'cart-undo';
    el.setAttribute('data-undo-id', entry.id);
    if (entry.held)      el.classList.add('is-held');
    if (entry.focused)   el.classList.add('is-focused');
    if (entry.restoring) el.classList.add('is-restoring');
    return el;
  }

  /* Draw (or re-draw after a re-render) every pending row, resuming each
     bar at its sampled progress. */
  function renderUndoRows() {
    Object.keys(pending).forEach(function (id) {
      var entry = pending[id];
      if (entry.elapsed >= UNDO_MS && !entry.restoring) { expire(id); return; }

      var list = listFor(entry.surface);
      if (!list) return;

      var strip  = stripFor(id);
      var anchor = null;
      if (entry.original && list.contains(entry.original)) {
        anchor = entry.original;                       // before the re-render lands
      } else {
        anchor = list.querySelectorAll('[data-line-key]')[entry.line.index] || null;
      }

      // already in place? (other Undo rows between the strip and its line don't count)
      if (strip && list.contains(strip)) {
        var next = strip.nextElementSibling;
        while (next && next.classList.contains('cart-undo')) next = next.nextElementSibling;
        if (next === anchor) return;
      }

      var hadFocus = !!(strip && strip.contains(document.activeElement));
      if (strip) { sampleEntry(entry, strip); strip.remove(); }

      strip = buildUndoRow(entry, Math.min(entry.elapsed, UNDO_MS));
      var btn = strip.querySelector('.cart-undo__btn');
      if (entry.restoring) btn.disabled = true;
      if (anchor) list.insertBefore(strip, anchor); else list.appendChild(strip);

      var focusLost = !document.activeElement || document.activeElement === document.body;
      if ((entry.focusUndo && !entry.placed) || hadFocus || (entry.focused && focusLost)) btn.focus();
      entry.placed = true;
    });
    cleanupHosts();
    startSampling();
  }

  /* ------------------------------------------------------------------ */
  /* the clock = the bar's CSS animation                                  */
  /* Its real progress is sampled each frame so a redraw resumes exactly   */
  /* where it was (paused time is never counted).                          */
  /* ------------------------------------------------------------------ */
  function sampleEntry(entry, strip) {
    var bar = strip && strip.querySelector('.cart-undo__bar');
    if (!bar || !bar.isConnected || typeof bar.getAnimations !== 'function') return;
    var anim = bar.getAnimations().filter(function (a) { return a.animationName === 'cart-undo-bar'; })[0];
    if (anim && anim.effect) {
      var p = anim.effect.getComputedTiming().progress;
      if (p !== null && p !== undefined) entry.elapsed = p * UNDO_MS;
    }
  }

  function startSampling() {
    if (sampling || !Object.keys(pending).length) return;
    sampling = true;
    (function tick() {
      var ids = Object.keys(pending);
      if (!ids.length) { sampling = false; return; }
      ids.forEach(function (id) { sampleEntry(pending[id], stripFor(id)); });
      requestAnimationFrame(tick);
    })();
  }

  document.addEventListener('animationend', function (e) {
    if (!e.target.classList || !e.target.classList.contains('cart-undo__bar')) return;
    var row = e.target.closest('.cart-undo');
    var id  = row && row.getAttribute('data-undo-id');
    var entry = id && pending[id];
    if (!entry) { if (row) row.remove(); return; }
    entry.elapsed = UNDO_MS;
    expire(id);
  });

  function removeEntryDom(entry) {
    document.querySelectorAll('.cart-undo[data-undo-id="' + entry.id + '"]').forEach(function (r) { r.remove(); });
    cleanupHosts();
  }

  /* Bar emptied: the row disappears and the snapshot is discarded. */
  function expire(id) {
    var entry = pending[id];
    if (!entry || entry.restoring) return;
    delete pending[id];
    removeEntryDom(entry);
  }

  /* Slide cart closed / Escape: its Undo rows end. */
  function clearPending(surface) {
    Object.keys(pending).forEach(function (id) {
      var entry = pending[id];
      if (entry.restoring || (surface && entry.surface !== surface)) return;
      delete pending[id];
      removeEntryDom(entry);
    });
  }

  function setFlag(id, flag, cls, on) {
    var entry = pending[id];
    if (!entry) return;
    entry[flag] = on;
    var strip = stripFor(id);
    if (strip) strip.classList.toggle(cls, on);
  }

  /* ------------------------------------------------------------------ */
  /* SLIDE CART — remove at the tap                                       */
  /* ------------------------------------------------------------------ */
  function removeLine(trigger, fromKeyboard) {
    var lineEl = trigger.closest('tr[data-line-key]');
    if (!lineEl || trigger.disabled) return;
    var line = readLine(lineEl);
    if (!line.key) return;

    var id = line.key + '-' + Date.now();
    var entry = pending[id] = {
      id: id, surface: 'drawer', line: line, original: lineEl, elapsed: 0,
      focusUndo: !!fromKeyboard, placed: false,
      held: false, focused: false, removed: false, restoring: false
    };

    // The Undo row takes the line's place straight away; the line itself
    // disappears for good when the re-rendered cart arrives.
    lineEl.style.display = 'none';
    renderUndoRows();

    entry.request = postJSON('/cart/change.js', {
      id: line.key, quantity: 0, sections: sectionIds(), sections_url: window.location.pathname
    }).then(function (cart) {
      entry.removed = true;
      entry.original = null;
      applySections(cart.sections, cart.item_count);
      announce('Removed ' + line.title + '. Undo available for ' + Math.round(UNDO_MS / 1000) + ' seconds.');
      track('cart_line_removed', line);
    }).catch(function () {
      // removal failed: nothing changed, show the line again
      delete pending[id];
      removeEntryDom(entry);
      lineEl.style.display = '';
      announce('Couldn\'t remove ' + line.title + '. Please try again.');
    });

    trackInflight(entry.request);
  }

  /* ------------------------------------------------------------------ */
  /* CART PAGE — remove at the tap                                        */
  /* ------------------------------------------------------------------ */
  function cartByKey(cart) {
    var map = {};
    cart.items.forEach(function (i) { map[i.key] = i; });
    return map;
  }

  /* Poll /cart.js until the page's own removal code has changed the cart
     (and it has settled), then work out exactly what it took out. */
  function detectRemoval(entry) {
    var started = Date.now(), lastSig = null;
    return new Promise(function (resolve) {
      (function poll() {
        fetch('/cart.js?_=' + Date.now(), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var byKey = cartByKey(cart);
            var changed = entry.snapshot.some(function (l) {
              var c = byKey[l.key];
              return !c || c.quantity !== l.quantity;
            });
            if (changed) {
              var sig = cart.items.map(function (i) { return i.key + ':' + i.quantity; }).sort().join('|');
              if (sig === lastSig) {            // unchanged for one more poll = settled
                var restore = [];
                entry.snapshot.forEach(function (l) {
                  var c = byKey[l.key];
                  var missing = l.quantity - (c ? c.quantity : 0);
                  if (missing > 0) restore.push(toAddItem(l, missing));
                });
                resolve(restore);
                return;
              }
              lastSig = sig;
            }
            if (Date.now() - started > 12000) { resolve(null); return; }
            setTimeout(poll, 350);
          })
          .catch(function () {
            if (Date.now() - started > 12000) resolve(null); else setTimeout(poll, 500);
          });
      })();
    });
  }

  function removeLinePage(trigger, fromKeyboard, viaMinus) {
    var lineEl = trigger.closest('li.cart-item[data-line-key]');
    if (!lineEl) return false;
    var line = readLine(lineEl);
    if (!line.key) return false;

    // everything on the page right now: what Undo can put back
    var snapshot = [];
    document.querySelectorAll(PAGE + ' li.cart-item[data-line-key]').forEach(function (el) { snapshot.push(readLine(el)); });

    var id = line.key + '-' + Date.now();
    var entry = pending[id] = {
      id: id, surface: 'page', line: line, original: lineEl, snapshot: snapshot, elapsed: 0,
      focusUndo: !!fromKeyboard, placed: false,
      held: false, focused: false, removed: false, restoring: false, restore: null
    };

    lineEl.style.display = 'none';
    renderUndoRows();

    // Trash at quantity 1 clicks the line's Remove link, so the page's own
    // removal code (linked add-on lines, free hanger) runs unchanged.
    if (viaMinus) {
      var link = lineEl.querySelector('cart-remove-button a.button--tertiary');
      if (link) {
        internalClick = true;
        try { link.click(); } finally { internalClick = false; }
      } else {
        entry.request = postJSON('/cart/change.js', { id: line.key, quantity: 0 }).then(function () {
          if (typeof window.updateCartSection === 'function') window.updateCartSection();
        });
      }
    }

    entry.request = detectRemoval(entry).then(function (restore) {
      if (!restore || !restore.length) {
        // nothing happened: put the line back
        delete pending[id];
        removeEntryDom(entry);
        lineEl.style.display = '';
        announce('Couldn\'t remove ' + line.title + '. Please try again.');
        return;
      }
      entry.removed = true;
      entry.restore = restore;
      announce('Removed ' + line.title + '. Undo available for ' + Math.round(UNDO_MS / 1000) + ' seconds.');
      track('cart_line_removed', line);
      refreshBubble();
    });

    trackInflight(entry.request);
    return true;
  }

  /* ------------------------------------------------------------------ */
  /* Undo: re-add the snapshot                                            */
  /* ------------------------------------------------------------------ */
  function undo(btn) {
    var row   = btn.closest('.cart-undo');
    var id    = row && row.getAttribute('data-undo-id');
    var entry = id && pending[id];
    if (!entry || entry.restoring) return;

    setFlag(id, 'restoring', 'is-restoring', true); // freezes the bar while the request runs
    btn.disabled = true;

    var p = entry.request.then(function () {
      if (!entry.removed) return; // removal failed and was already rolled back

      if (entry.surface === 'page') {
        return postJSON('/cart/add.js', { items: entry.restore }).then(function () {
          // let the page redraw itself the way it always does, then drop the row
          if (typeof window.updateCartSection === 'function') window.updateCartSection();
          else { window.location.reload(); return; }
          return new Promise(function (resolve) {
            var t0 = Date.now();
            (function wait() {
              var back = document.querySelector(PAGE + ' li.cart-item[data-variant-id="' + entry.line.variantId + '"]:not([style*="display: none"])');
              if (back || Date.now() - t0 > 6000) { resolve(); return; }
              setTimeout(wait, 150);
            })();
          }).then(function () {
            delete pending[id];
            removeEntryDom(entry);
            refreshBubble();
            announce(entry.line.title + ' is back in your cart.');
            track('cart_line_restored', entry.line);
          });
        });
      }

      var c = entry.line;
      return postJSON('/cart/add.js', {
        items: [toAddItem(c)], sections: sectionIds(), sections_url: window.location.pathname
      }).then(function (res) {
        delete pending[id];
        removeEntryDom(entry);
        applySections(res.sections, 1); // the cart has a line again, so drop the empty-cart state
        announce(c.title + ' is back in your cart.');
        track('cart_line_restored', c);
      });
    }).catch(function () {
      setFlag(id, 'restoring', 'is-restoring', false); // bar resumes
      var b = stripFor(id) && stripFor(id).querySelector('.cart-undo__btn');
      if (b) b.disabled = false;
      announce('Couldn\'t restore ' + entry.line.title + '. Please try again.');
    });

    trackInflight(p);
  }

  /* ------------------------------------------------------------------ */
  /* events                                                               */
  /* ------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    if (internalClick) return;

    // ---- slide cart: trash (the minus button at quantity 1)
    var dec = e.target.closest(DRAWER + ' .quantity__button[name="minus"]');
    if (dec) {
      var lineEl = dec.closest('tr[data-line-key]');
      var qtyEl  = lineEl && lineEl.querySelector('.quantity__input');
      if (qtyEl && Number(qtyEl.value) === 1) {
        e.preventDefault();
        e.stopImmediatePropagation();
        removeLine(dec, e.detail === 0);
      }
      return;
    }
    // slide cart: lines without a stepper still have their own Remove button
    var rm = e.target.closest(DRAWER + ' cart-remove-button');
    if (rm && rm.closest('tr[data-line-key]')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      removeLine(rm, e.detail === 0);
      return;
    }

    // ---- cart page: trash at quantity 1 → runs the page's own Remove code
    var pdec = e.target.closest(PAGE + ' .quantity__button[name="minus"]');
    if (pdec) {
      var pli = pdec.closest('li.cart-item[data-line-key]');
      var pq  = pli && pli.querySelector('.quantity__input');
      if (pq && Number(pq.value) === 1 && pli.style.display !== 'none') {
        e.preventDefault();
        e.stopImmediatePropagation();
        removeLinePage(pdec, e.detail === 0, true);
      }
      return;
    }
    // cart page: the Remove link itself (lines without a stepper) — the page's
    // own handler continues; we only add the Undo row and watch for the result
    var prm = e.target.closest(PAGE + ' cart-remove-button a.button--tertiary');
    if (prm) {
      var pli2 = prm.closest('li.cart-item[data-line-key]');
      if (pli2 && pli2.style.display !== 'none') removeLinePage(prm, e.detail === 0, false);
      return;
    }

    var undoBtn = e.target.closest('.cart-undo__btn');
    if (undoBtn) { e.preventDefault(); undo(undoBtn); }
  }, true);

  /* Checkout must never open with a line that is still being removed. */
  function waitThenCheckout(trigger) {
    inflightChain.then(function () {
      if (trigger && trigger.isConnected) { trigger.click(); return; }
      var fresh = (trigger && trigger.id && document.getElementById(trigger.id)) ||
                  document.getElementById('CartDrawer-Checkout') || document.querySelector('[name="checkout"]');
      if (fresh) fresh.click(); else window.location.href = '/checkout';
    });
  }

  document.addEventListener('click', function (e) {
    if (!inflight) return;
    var co = e.target.closest('#CartDrawer-Checkout, ' + PAGE + ' [name="checkout"], ' + PAGE + ' #checkout');
    if (!co) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    waitThenCheckout(co);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!inflight) return;
    var isCheckout = (e.submitter && e.submitter.name === 'checkout') ||
                     e.target.id === 'CartDrawer-Form' || e.target.id === 'cart';
    if (!isCheckout) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    waitThenCheckout(e.submitter || null);
  }, true);

  /* Pausing. Mouse hover on real hover devices is pure CSS
     ((hover: hover) and (pointer: fine)). Keyboard focus on Undo uses
     :has(:focus-visible) plus the is-focused class for browsers without :has.
     A finger or pen held on the row adds is-held. */
  function rowId(target) {
    var row = target && target.closest && target.closest('.cart-undo');
    return row ? row.getAttribute('data-undo-id') : null;
  }

  document.addEventListener('focusin', function (e) {
    if (!e.target.classList || !e.target.classList.contains('cart-undo__btn')) return;
    var visible = true;
    try { visible = e.target.matches(':focus-visible'); } catch (err) { visible = true; }
    var id = rowId(e.target);
    if (id && visible) setFlag(id, 'focused', 'is-focused', true);
  });

  document.addEventListener('focusout', function (e) {
    var btn = e.target;
    if (!btn.classList || !btn.classList.contains('cart-undo__btn')) return;
    var id = rowId(btn);
    if (!id) return;
    // focusout fires just BEFORE a redraw removes the button, so decide
    // afterwards: still attached = focus moved away; detached = a redraw took
    // it, keep the flag so focus is restored on the new row.
    queueMicrotask(function () {
      if (btn.isConnected && document.activeElement !== btn) setFlag(id, 'focused', 'is-focused', false);
    });
  });

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var id = rowId(e.target);
    if (id) setFlag(id, 'held', 'is-held', true);
  });

  ['pointerup', 'pointercancel'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (e.pointerType === 'mouse') return;
      Object.keys(pending).forEach(function (id) {
        if (pending[id].held) setFlag(id, 'held', 'is-held', false);
      });
    });
  });

  /* Slide cart closed / Escape → its Undo rows end */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#CartDrawer-Overlay, #CartDrawer .drawer__close')) clearPending('drawer');
  });
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape' && document.querySelector('cart-drawer.active')) clearPending('drawer');
  });

  /* Any other re-render (the page's own refresh, the theme's quantity change,
     a builder add-to-cart) wipes the row; put it back at the bar's progress. */
  new MutationObserver(function () {
    if (!Object.keys(pending).length) return;
    var broken = Object.keys(pending).some(function (id) { return !stripFor(id); });
    if (broken) renderUndoRows();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.AnsonCartUndo = { renderUndoRows: renderUndoRows, clearPending: clearPending };
})();
